var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-comments"},[_c('h3',[_vm._v("Comments")]),_vm._v(" "),_c('video-comments-list',{attrs:{"comments":_vm.comments,"group":"root","video":_vm.video,"serie":_vm.serie}}),_vm._v(" "),_c('video-comment-form',{attrs:{"video":_vm.video,"serie":_vm.serie}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }